import { useState, useEffect } from 'react';
import LoginPage from '../components/LoginPage';
import Dashboard from '../components/Dashboard';
import { useSelector } from 'react-redux';
import { selectPrefix } from '../utility/Redux/profile';

export default function ShopKeeprApp() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [currentPath, setCurrentPath] = useState(window.location.hash.slice(1) || '/');

  const prefix = useSelector(selectPrefix)

 

  const handleLogin = () => {
    setIsAuthenticated(true);
    window.location.href = '/dashboard/balance';
  };
   
  const handleLogout = () => {
    setIsAuthenticated(false);
    localStorage.clear()
  
    window.location.href = '/login';
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100">
      {!prefix  ? (
        <LoginPage onLogin={handleLogin} />
      ) : (
        <Dashboard onLogout={handleLogout} />
      )}
    </div>
  );
}
